/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum StatusEnum {
    ONLINE = 'online',
    DOWN = 'down',
    MAINT = 'maintenance',
    DRAIN = 'drain',
    HALT = 'halt',
    PENDING = 'pending'
}
